/*-------------------------------------------------------------------
							Magnifier.js互換のルーペルーチン
							Magnifier.jsがうまく動かなかったため、jqueryで作成

		作成日:2019年7月8日
/*--------------------------------------------------------------------*/

$(function(){
		$('.js-magnifier-image').hover(function(){
			//マウスが画像に入った時
			var url = $(this).attr("data-large-img-url");	//data属性で取得するとデータがキャッシュされてる
			txt = "<img id='preview_img' class='magnifier-preview' src='"+url+"'>";
			$("#preview").html(txt);
			$("#preview").show(50);
			$("#preview_img").show(50);
		},function(){
			//マウスが画像から外れた時
			$("#preview").hide(50);
			$("#preview_img").hide(50);
		}); 	 

		//マウスが画像から動いた時
		$('.js-magnifier-image').mousemove(function(event){

			var preview =$("#preview");
			var preview_img =$("#preview_img");

			//拡大ボックスの縦横サイズを変える
			var pre_height = preview.width() * (preview_img.height() / preview_img.width());
		
			preview.height(pre_height);
			var xretio = preview_img.width() / $(this).width();
			var yretio = preview_img.height() / $(this).height();

			var top = ((event.offsetY - ($(this).width() / 3)) * yretio) * -1;
			var left = ((event.offsetX - ($(this).height() / 3)) * xretio) * -1;

			if(event.offsetY < ($(this).width() / 3) ) top = 0;
			if(event.offsetX	< ($(this).height() / 3) ) left = 0;

			//端っこ処理
			if(((top*-1) + preview.height()) > preview_img.height()) top = (preview_img.height() - preview.height())*-1;
			if(((left*-1) + preview.width()) > preview_img.width()) left = (preview_img.width() - preview.width())*-1;

			preview_img.css({"top":top,"left":left})

		});

});
